var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "top-section-instagram _js-scroll-animation-trigger" },
    [
      _c("div", { staticClass: "inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "photos" },
          _vm._l(_vm.photoList, function(photo) {
            return _c("li", { key: photo.id }, [
              _c("a", { attrs: { href: photo.permalink, target: "_blank" } }, [
                _c("img", { attrs: { src: photo.media_url, alt: "" } })
              ])
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "p-hdg-weng -top" }, [
      _vm._v("INSTAGRAM"),
      _c("span", { staticClass: "en" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/giontsujirisaryotsujiri/",
              target: "_blank"
            }
          },
          [_vm._v("@giontsujirisaryotsujiri")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }